<div class="savings-container">
  <a textCta href="#" (click)="goToSavingsPage($event)" class="savings-link">
    <span *ngIf="savingsInCents">Find out how this seller is saving {{ savingsInDollars(savingsInCents) | currency : 'USD' : 'symbol' : '1.0-0' }}</span>
    <span *ngIf="!savingsInCents">Find out how our sellers save an average of $15,000!</span>
    <fa class="external-link-icon" name="external-link"></fa>
  </a>
</div>
